// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2jzzE","select":"Header_select__aVOYt","clinic":"Header_clinic__dMk5r"};